import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "m9.2 22 3-7", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m9 13-3 7", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m17 13-3 7", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "CloudRainWind";
const CloudRainWind = memo(themed(Icon));
export {
  CloudRainWind
};
//# sourceMappingURL=cloud-rain-wind.js.map
